import { render, staticRenderFns } from "./SystemDeleteModal.vue?vue&type=template&id=6082f937&"
import script from "./SystemDeleteModal.vue?vue&type=script&lang=js&"
export * from "./SystemDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports